import React, { useEffect, useState } from 'react';
import ValidatingInput from '../ValidatingInput/ValidatingInput';
import { JOKI } from '../../JOKI';

export default function ParentSelector(props) {
    const [parentOptions, setParentOptions] = useState();

    useEffect(() => {
        async function getAvailableParents(ownerCodes) {
            const results = await JOKI.ask({
                from: 'React:CrudParentLocationDropDown',
                to: props.serviceId,
                key: 'getAvailableParents',
                body: ownerCodes,
            });

            if (results && results[props.serviceId]) {
                const options = results[props.serviceId] || [];
                options.unshift({ label: 'No Parents', value: '' });
                setParentOptions(options);
            }
        }
        getAvailableParents(props.dataSet.owners);
    }, [props.dataSet]);

    let valueObject = null;

    if (Array.isArray(parentOptions)) {
        valueObject = parentOptions.find(pobj => pobj.value === props.dataSet[props.dataKey]) || {};
    }

    return (
        <>
            {valueObject && Array.isArray(parentOptions) && (
                <ValidatingInput
                    label={props.label}
                    dataSet={props.dataSet}
                    dataKey={props.dataKey}
                    valueObject={valueObject}
                    onChange={props.onChange}
                    options={parentOptions}
                    validationFn={val => {
                        return parentOptions.findIndex(po => po.value === val.value) > -1;
                    }}
                    validationType="select"
                />
            )}
        </>
    );
}
